import { io, Socket } from 'socket.io-client'
import type { ClientToServerEvents, ServerToClientEvents } from 'chat-shared'

export type ChatSocket = Socket<ServerToClientEvents, ClientToServerEvents>

let socket: ChatSocket | undefined

// Eine Verbindung pro Browser-Tab: die Session-Cookie-Auth läuft beim
// Handshake, danach bleibt die Verbindung über Chat-Wechsel hinweg bestehen.
export const getChatSocket = (): ChatSocket => {
  if (!socket) {
    socket = io('/chat', { withCredentials: true })
  }
  return socket
}
